import React from 'react';
import {Routes, Route } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
import Home from './pages/home';
import About from './pages/about';
import Archievements from './pages/archievements';
import Projects from './pages/projects-and-clients';

function routes(){
    return <>
<Header/>
<Routes >  
<Route path="/" element={<Home /> } />
<Route path="/about-us" element={<About/> } />
<Route path="/archievements" element={<Archievements/> } />
<Route path="/projects-and-clients" element={<Projects/> } />
</Routes>
<Footer/>
    </>
}
export default routes;